import { render, staticRenderFns } from "./SettingsSanitizeFilenames.vue?vue&type=template&id=51ab1271&scoped=true"
import script from "./SettingsSanitizeFilenames.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsSanitizeFilenames.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SettingsSanitizeFilenames.vue?vue&type=style&index=0&id=51ab1271&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ab1271",
  null
  
)

export default component.exports